var _path, _g, _path2, _path3, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRuralIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_941_2368",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.62939e-06H60V60H0V7.62939e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_941_2368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9807 26.7361L0.878906 21.217",
    stroke: "#0097A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9725 28.2117L46.083 27.2871",
    stroke: "#0097A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_941_2368",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.62939e-06H60V60H0V7.62939e-06Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_941_2368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.50664 38.8688C3.96445 39.0376 2.42109 39.1958 0.878906 39.3481",
    stroke: "#0097A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7186 35.816C23.2779 36.4699 19.7857 37.0359 16.2666 37.5352",
    stroke: "#0097A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.121 25.2984C53.7854 28.1074 47.9987 30.3527 41.9097 32.1726",
    stroke: "#0097A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.644 37.7178V44.469",
    stroke: "#0097A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3877 48.5483V37.7179",
    stroke: "#0097A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1051 32.1728H28.9266C28.7529 32.1728 28.5934 32.2689 28.5122 32.4225L25.8961 37.3742C25.8136 37.5303 25.9268 37.718 26.1034 37.718H54.9284C55.105 37.718 55.2181 37.5303 55.1356 37.3742L52.5196 32.4225C52.4384 32.2689 52.2789 32.1728 52.1051 32.1728Z",
    stroke: "#0097A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2378 40.5764H47.7556",
    stroke: "#0097A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7568 40.5764H41.2745",
    stroke: "#0097A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2759 40.5764H34.7936",
    stroke: "#0097A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9316 17.6045H59.1209",
    stroke: "#0097A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878906 17.6045H12.8303",
    stroke: "#0097A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.47314 43.7591C5.97666 42.838 7.18838 41.6673 8.17041 40.2962C8.25713 40.1743 8.18916 40.0056 8.04268 39.9728C7.30557 39.8087 6.56846 39.5942 5.83018 39.3294C5.43408 39.1864 5.39307 38.6474 5.75869 38.4388C7.22236 37.5985 8.34853 36.4677 9.21924 35.1165C9.30127 34.9911 9.22979 34.8247 9.08213 34.7966C8.27705 34.6478 7.47197 34.4321 6.66689 34.1438C6.32705 34.022 6.28135 33.5544 6.59424 33.3751C9.13486 31.9185 10.4966 29.4435 11.2489 26.4446C11.3591 26.0063 11.9813 26.0063 12.0915 26.4446C12.8438 29.4435 14.2056 31.9185 16.7462 33.3751C17.0591 33.5544 17.0134 34.022 16.6735 34.1438C15.8685 34.4321 15.0634 34.6478 14.2583 34.7966C14.1106 34.8247 14.0392 34.9911 14.1212 35.1165C14.9919 36.4677 16.1181 37.5985 17.5817 38.4388C17.9474 38.6474 17.9063 39.1864 17.5103 39.3294C16.7731 39.5942 16.0349 39.8087 15.2978 39.9728C15.1513 40.0056 15.0833 40.1743 15.17 40.2962C16.1626 41.6825 17.3907 42.8649 18.9177 43.7896",
    stroke: "#0097A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878906 54.3652H59.1211",
    stroke: "#0097A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1211 50.3521C38.3753 44.3451 19.2146 42.936 0.878906 43.9194",
    stroke: "#0097A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7031 17.6045V13.6727",
    stroke: "#0097A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8087 6.26813L27.7421 12.1311C27.4767 12.8838 28.0353 13.6729 28.8333 13.6729H32.5735C33.3715 13.6729 33.9299 12.8838 33.6646 12.1311L31.5981 6.26813C31.3003 5.42367 30.1063 5.42367 29.8087 6.26813Z",
    stroke: "#0097A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.689 17.6045V13.6727",
    stroke: "#0097A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.794 6.26813L37.7274 12.1311C37.4622 12.8838 38.0206 13.6729 38.8186 13.6729H42.5588C43.3568 13.6729 43.9153 12.8838 43.6499 12.1311L41.5834 6.26813C41.2856 5.42367 40.0916 5.42367 39.794 6.26813Z",
    stroke: "#0097A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6743 17.6045V13.6727",
    stroke: "#0097A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7799 6.26813L47.7132 12.1311C47.448 12.8838 48.0064 13.6729 48.8046 13.6729H52.5446C53.3427 13.6729 53.9012 12.8838 53.6359 12.1311L51.5693 6.26813C51.2716 5.42367 50.0775 5.42367 49.7799 6.26813Z",
    stroke: "#0097A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuralIc);
export default __webpack_public_path__ + "static/media/rural-ic.7ef7543626b87eb61d851ea107b75430.svg";
export { ForwardRef as ReactComponent };